import { skipToken } from "@reduxjs/toolkit/query";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

import {
  useDeleteProductUpdateMutation,
  useListProductUpdatesQuery,
  useUpdateProductUpdateMutation,
} from "api/memberPortal/product/productUpdate/productUpdate.api";
import { ProductUpdate } from "api/memberPortal/product/productUpdate/productUpdate.types";

import { buildProductUpdateColumns } from "./components/updateTable/ProductUpdates.columns";
import ProductUpdatesBase from "./ProductUpdatesBase.screen";

const EMPTY_ARRAY: ProductUpdate[] = [];

const ProductUpdates = () => {
  const { id: parentId } = useParams();

  const [triggerDelete] = useDeleteProductUpdateMutation();
  const [triggerUpdate] = useUpdateProductUpdateMutation();

  const updateQueryParam = parentId ? { parentId } : skipToken;
  const { data: productUpdates = EMPTY_ARRAY, isLoading } =
    useListProductUpdatesQuery(updateQueryParam);

  const columns = useMemo(
    () =>
      buildProductUpdateColumns<ProductUpdate>({
        onArchive: triggerDelete,
        onUnarchive: triggerUpdate,
        getParentId: (productUpdate) => productUpdate.product,
      }),
    [triggerDelete, triggerUpdate],
  );

  return (
    <ProductUpdatesBase
      productUpdates={productUpdates}
      isLoading={isLoading}
      columns={columns}
    />
  );
};
export default ProductUpdates;
